var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnatomyNeck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF5959",
    strokeMiterlimit: 10,
    d: "M4 3.035V20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5959",
    d: "M4 7.5C2.07 7.5.5 5.93.5 4S2.07.5 4 .5 7.5 2.07 7.5 4 5.93 7.5 4 7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4 1c1.654 0 3 1.346 3 3S5.654 7 4 7 1 5.654 1 4s1.346-3 3-3m0-1a4 4 0 100 8 4 4 0 000-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5959",
    d: "M4 23.5C2.07 23.5.5 21.93.5 20s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4 17c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-1a4 4 0 100 8 4 4 0 000-8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnatomyNeck);
export default __webpack_public_path__ + "static/media/anatomy-neck.66c02a8f97f6a1d75196291b7f0a3514.svg";
export { ForwardRef as ReactComponent };